import logo from "../images/log.png";
import { NavLink } from "react-router-dom";

const Footer = () => {
  return (
    <footer>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[25px] lg:gap-[60px] px-[50px] py-[50px] bg-[#1e1e1e] text-white h-[auto] rounded-[15px] my-[40px] mx-[15px]">
        <div className="flex items-start gap-[20px]">
          <i className="fa-solid fa-money-check-dollar relative top-2 text-[30px]"></i>
          <div>
            <h4 className="font-[700] text-[18px]">Secure payments</h4>
            <p>Lorem ipsum dolor sit amet consectetur esse.</p>
          </div>
        </div>
        <div className="flex items-start gap-[20px]">
          <i className="fa-solid fa-truck-fast relative top-2 text-[30px]"></i>
          <div>
            <h4 className="font-[700] text-[18px]">Free Shipping</h4>
            <p>Lorem ipsum dolor sit amet consectetur esse.</p>
          </div>
        </div>
        <div className="flex items-start gap-[20px]">
          <i className="fa-solid fa-comments relative top-2 text-[30px]"></i>
          <div>
            <h4 className="font-[700] text-[18px]">24/7 Support</h4>
            <p>Lorem ipsum dolor sit amet consectetur esse.</p>
          </div>
        </div>
        <div className="flex items-start gap-[20px]">
          <i className="fa-solid fa-gift relative top-2 text-[30px]"></i>
          <div>
            <h4 className="font-[700] text-[18px]">Gifts & Sales</h4>
            <p>Lorem ipsum dolor sit amet consectetur esse.</p>
          </div>
        </div>
      </div>

      <div className="mt-[100px] mb-[50px] px-[5px]">
        <div className="flex flex-col lg:flex-row items-center lg:items-start text-center lg:text-left justify-between mx-[50px]">
          <div className="w-[100%] lg:w-[40%]">
            <NavLink to="/" onClick={() => window.scrollTo({ top: 0 })}>
              <img
                src={logo}
                alt=""
                className="h-[50px] mb-4 relative left-[50%] translate-x-[-50%] lg:left-[0%] lg:translate-x-[0%]"
              />
            </NavLink>
            <p className="mb-[30px] lg:mb-[0]">
              Discover our unique assortment of children's apparel and
              playthings in preparation for the upcoming fall season.
            </p>
          </div>
          <button className="pr-3 pl-1 border-[1px] border-black rounded-full py-1 hover:bg-slate-100">
            <i className="fa-solid fa-phone bg-black text-[14px] mr-[5px] text-white p-3 rounded-full"></i>
            +234 906 835 1922
          </button>
        </div>
      </div>

      <hr />

      <div className="my-[50px] grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[50px] px-[50px] text-center lg:text-left">
        <div>
          <h4 className="text-[20px] font-[600] mb-[15px]">Shop</h4>
          <ul className="grid gap-2">
            <li>
              <NavLink
                to="/appliances"
                onClick={() => {
                  window.scrollTo({ top: 0 });
                }}
                className="hover:text-amber-500"
              >
                Home Appliances
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/accessories"
                onClick={() => {
                  window.scrollTo({ top: 0 });
                }}
                className="hover:text-amber-500"
              >
                Accessories
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/phones"
                onClick={() => {
                  window.scrollTo({ top: 0 });
                }}
                className="hover:text-amber-500"
              >
                Mobile Phones
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/laptop"
                onClick={() => {
                  window.scrollTo({ top: 0 });
                }}
                className="hover:text-amber-500"
              >
                Laptops
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/games"
                onClick={() => {
                  window.scrollTo({ top: 0 });
                }}
                className="hover:text-amber-500"
              >
                Games
              </NavLink>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="text-[20px] font-[600] mb-[15px]">Pages</h4>
          <ul className="grid gap-2">
            <li>
              <NavLink
                to="/"
                onClick={() => {
                  window.scrollTo({ top: 0 });
                }}
                className="hover:text-amber-500"
                href="#"
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/shop"
                onClick={() => {
                  window.scrollTo({ top: 0 });
                }}
                className="hover:text-amber-500"
                href="#"
              >
                Shop
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/news"
                onClick={() => {
                  window.scrollTo({ top: 0 });
                }}
                className="hover:text-amber-500"
                href="#"
              >
                News
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/contact"
                onClick={() => {
                  window.scrollTo({ top: 0 });
                }}
                className="hover:text-amber-500"
                href="#"
              >
                Contact
              </NavLink>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="text-[20px] font-[600] mb-[15px]">Useful</h4>
          <ul className="grid gap-2">
            <li>
              <a className="hover:text-amber-500" href="#">
                Sitemap
              </a>
            </li>
            <li>
              <a className="hover:text-amber-500" href="#">
                Delivery
              </a>
            </li>
            <li>
              <a className="hover:text-amber-500" href="#">
                Locations
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="text-[20px] font-[600] mb-[15px]">Legal</h4>
          <ul className="grid gap-2">
            <li>
              <a className="hover:text-amber-500" href="#">
                Terms of Use
              </a>
            </li>
            <li>
              <a className="hover:text-amber-500" href="#">
                Privacy Policy
              </a>
            </li>
            <li>
              <a className="hover:text-amber-500" href="#">
                Cookies Policy
              </a>
            </li>
          </ul>
        </div>
      </div>
      <hr />
      <div className="flex flex-col lg:flex-row items-center justify-between gap-5 py-[30px]">
        <p className="">
          Copyright &copy; designed by{" "}
          <a href="https://ireskitech.com" className="text-amber-500">
            Ireski
          </a>{" "}
          2025.
        </p>
        <div className="flex items-center gap-3">
          <a href="https://x.com/ireski757" target="_blank">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 640 640"
              className="text-gray-400 hover:text-amber-500 h-[30px]"
            >
              <path
                className="fill-current"
                d="M160 96C124.7 96 96 124.7 96 160L96 480C96 515.3 124.7 544 160 544L480 544C515.3 544 544 515.3 544 480L544 160C544 124.7 515.3 96 480 96L160 96zM457.1 180L353.3 298.6L475.4 460L379.8 460L305 362.1L219.3 460L171.8 460L282.8 333.1L165.7 180L263.7 180L331.4 269.5L409.6 180L457.1 180zM419.3 431.6L249.4 206.9L221.1 206.9L392.9 431.6L419.3 431.6z"
              />
            </svg>
          </a>
          <a href="https://web.facebook.com/erhabor.iredia.12" target="_blank">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 640 640"
              className="text-gray-400 hover:text-amber-500 h-[30px]"
            >
              <path
                className="fill-current"
                d="M160 96C124.7 96 96 124.7 96 160L96 480C96 515.3 124.7 544 160 544L258.2 544L258.2 398.2L205.4 398.2L205.4 320L258.2 320L258.2 286.3C258.2 199.2 297.6 158.8 383.2 158.8C399.4 158.8 427.4 162 438.9 165.2L438.9 236C432.9 235.4 422.4 235 409.3 235C367.3 235 351.1 250.9 351.1 292.2L351.1 320L434.7 320L420.3 398.2L351 398.2L351 544L480 544C515.3 544 544 515.3 544 480L544 160C544 124.7 515.3 96 480 96L160 96z"
              />
            </svg>
          </a>
          <a href="https://www.instagram.com/ireski75/" target="_blank">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 640 640"
              className="text-gray-400 h-[30px] hover:text-amber-500"
            >
              <path
                className="fill-current"
                d="M290.4 275.7C274 286 264.5 304.5 265.5 323.8C266.6 343.2 278.2 360.4 295.6 368.9C313.1 377.3 333.8 375.5 349.6 364.3C366 354 375.5 335.5 374.5 316.2C373.4 296.8 361.8 279.6 344.4 271.1C326.9 262.7 306.2 264.5 290.4 275.7zM432.7 207.3C427.5 202.1 421.2 198 414.3 195.3C396.2 188.2 356.7 188.5 331.2 188.8C327.1 188.8 323.3 188.9 320 188.9C316.7 188.9 312.8 188.9 308.6 188.8C283.1 188.5 243.8 188.1 225.7 195.3C218.8 198 212.6 202.1 207.3 207.3C202 212.5 198 218.8 195.3 225.7C188.2 243.8 188.6 283.4 188.8 308.9C188.8 313 188.9 316.8 188.9 320C188.9 323.2 188.9 327 188.8 331.1C188.6 356.6 188.2 396.2 195.3 414.3C198 421.2 202.1 427.4 207.3 432.7C212.5 438 218.8 442 225.7 444.7C243.8 451.8 283.3 451.5 308.8 451.2C312.9 451.2 316.7 451.1 320 451.1C323.3 451.1 327.2 451.1 331.4 451.2C356.9 451.5 396.2 451.9 414.3 444.7C421.2 442 427.4 437.9 432.7 432.7C438 427.5 442 421.2 444.7 414.3C451.9 396.3 451.5 356.9 451.2 331.3C451.2 327.1 451.1 323.2 451.1 319.9C451.1 316.6 451.1 312.8 451.2 308.5C451.5 283 451.9 243.6 444.7 225.5C442 218.6 437.9 212.4 432.7 207.1L432.7 207.3zM365.6 251.8C383.7 263.9 396.2 282.7 400.5 304C404.8 325.3 400.3 347.5 388.2 365.6C382.2 374.6 374.5 382.2 365.6 388.2C356.7 394.2 346.6 398.3 336 400.4C314.7 404.6 292.5 400.2 274.4 388.1C256.3 376 243.8 357.2 239.5 335.9C235.2 314.6 239.7 292.4 251.7 274.3C263.7 256.2 282.6 243.7 303.9 239.4C325.2 235.1 347.4 239.6 365.5 251.6L365.6 251.6zM394.8 250.5C391.7 248.4 389.2 245.4 387.7 241.9C386.2 238.4 385.9 234.6 386.6 230.8C387.3 227 389.2 223.7 391.8 221C394.4 218.3 397.9 216.5 401.6 215.8C405.3 215.1 409.2 215.4 412.7 216.9C416.2 218.4 419.2 220.8 421.3 223.9C423.4 227 424.5 230.7 424.5 234.5C424.5 237 424 239.5 423.1 241.8C422.2 244.1 420.7 246.2 419 248C417.3 249.8 415.1 251.2 412.8 252.2C410.5 253.2 408 253.7 405.5 253.7C401.7 253.7 398 252.6 394.9 250.5L394.8 250.5zM544 160C544 124.7 515.3 96 480 96L160 96C124.7 96 96 124.7 96 160L96 480C96 515.3 124.7 544 160 544L480 544C515.3 544 544 515.3 544 480L544 160zM453 453C434.3 471.7 411.6 477.6 386 478.9C359.6 480.4 280.4 480.4 254 478.9C228.4 477.6 205.7 471.7 187 453C168.3 434.3 162.4 411.6 161.2 386C159.7 359.6 159.7 280.4 161.2 254C162.5 228.4 168.3 205.7 187 187C205.7 168.3 228.5 162.4 254 161.2C280.4 159.7 359.6 159.7 386 161.2C411.6 162.5 434.3 168.3 453 187C471.7 205.7 477.6 228.4 478.8 254C480.3 280.3 480.3 359.4 478.8 385.9C477.5 411.5 471.7 434.2 453 452.9L453 453z"
              />
            </svg>
          </a>
          <a href="" target="_blank" rel="noopener noreferrer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 640 640"
              className="text-gray-400 hover:text-amber-500 h-[30px]"
            >
              <path
                className="fill-current"
                d="M512 96L127.9 96C110.3 96 96 110.5 96 128.3L96 511.7C96 529.5 110.3 544 127.9 544L512 544C529.6 544 544 529.5 544 511.7L544 128.3C544 110.5 529.6 96 512 96zM231.4 480L165 480L165 266.2L231.5 266.2L231.5 480L231.4 480zM198.2 160C219.5 160 236.7 177.2 236.7 198.5C236.7 219.8 219.5 237 198.2 237C176.9 237 159.7 219.8 159.7 198.5C159.7 177.2 176.9 160 198.2 160zM480.3 480L413.9 480L413.9 376C413.9 351.2 413.4 319.3 379.4 319.3C344.8 319.3 339.5 346.3 339.5 374.2L339.5 480L273.1 480L273.1 266.2L336.8 266.2L336.8 295.4L337.7 295.4C346.6 278.6 368.3 260.9 400.6 260.9C467.8 260.9 480.3 305.2 480.3 362.8L480.3 480z"
              />
            </svg>
          </a>

          <a href="https://github.com/Ireski" target="_blank">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 640 640"
              className="text-gray-400 h-[30px] hover:text-amber-500"
            >
              <path
                className="fill-current"
                d="M544 160C544 124.7 515.3 96 480 96L160 96C124.7 96 96 124.7 96 160L96 480C96 515.3 124.7 544 160 544L480 544C515.3 544 544 515.3 544 480L544 160zM361.8 471.7C361.8 469.9 361.8 465.7 361.9 460.1C362 448.7 362 431.3 362 416.4C362 400.8 356.8 390.9 350.7 385.7C387.7 381.6 426.7 376.5 426.7 312.6C426.7 294.4 420.2 285.3 409.6 273.6C411.3 269.3 417 251.6 407.9 228.6C394 224.3 362.2 246.5 362.2 246.5C335.6 239 305.6 239 279 246.5C279 246.5 247.2 224.3 233.3 228.6C224.2 251.5 229.8 269.2 231.6 273.6C221 285.3 216 294.4 216 312.6C216 376.2 253.3 381.6 290.3 385.7C285.5 390 281.2 397.4 279.7 408C270.2 412.3 245.9 419.7 231.4 394.1C222.3 378.3 205.9 377 205.9 377C189.7 376.8 204.8 387.2 204.8 387.2C215.6 392.2 223.2 411.4 223.2 411.4C232.9 441.1 279.3 431.1 279.3 431.1C279.3 440.1 279.4 452.8 279.4 461.7C279.4 466.5 279.5 470.3 279.5 471.7C279.5 476 276.5 481.2 268 479.7C202 457.6 155.8 394.8 155.8 321.4C155.8 229.6 226 159.9 317.8 159.9C409.6 159.9 484 229.6 484 321.4C484.1 394.8 439.3 457.7 373.3 479.7C364.9 481.2 361.8 476 361.8 471.7zM271.3 416.9C271.1 415.4 272.4 414.1 274.3 413.7C276.2 413.5 278 414.3 278.2 415.6C278.5 416.9 277.2 418.2 275.2 418.6C273.3 419 271.5 418.2 271.3 416.9zM262.2 420.1C260 420.3 258.5 419.2 258.5 417.7C258.5 416.4 260 415.3 262 415.3C263.9 415.1 265.7 416.2 265.7 417.7C265.7 419 264.2 420.1 262.2 420.1zM247.9 417.9C246 417.5 244.7 416 245.1 414.7C245.5 413.4 247.5 412.8 249.2 413.2C251.2 413.8 252.5 415.3 252 416.6C251.6 417.9 249.6 418.5 247.9 417.9zM235.4 410.6C233.9 409.3 233.5 407.4 234.5 406.5C235.4 405.4 237.3 405.6 238.8 407.1C240.1 408.4 240.6 410.4 239.7 411.2C238.8 412.3 236.9 412.1 235.4 410.6zM226.9 400.6C225.8 399.1 225.8 397.4 226.9 396.7C228 395.8 229.7 396.5 230.6 398C231.7 399.5 231.7 401.3 230.6 402.1C229.7 402.7 228 402.1 226.9 400.6zM220.6 391.8C219.5 390.5 219.3 389 220.2 388.3C221.1 387.4 222.6 387.9 223.7 388.9C224.8 390.2 225 391.7 224.1 392.4C223.2 393.3 221.7 392.8 220.6 391.8zM214.6 385.4C213.3 384.8 212.7 383.7 213.1 382.8C213.5 382.2 214.6 381.9 215.9 382.4C217.2 383.1 217.8 384.2 217.4 385C217 385.9 215.7 386.1 214.6 385.4z"
              />
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
